import { Button, Modal, Stack, Text } from '@inflearn/ds-react';
import { useTranslation } from 'next-i18next';

interface Props {
  opened: boolean;
  onClose: () => void;
  onNaverPayClick: () => void;
}

export const NaverPayReceiptModal = ({ opened, onClose, onNaverPayClick }: Props) => {
  const { t } = useTranslation();

  return (
    <Modal.Root opened={opened} onClose={onClose} size="sm" centered>
      <Modal.Overlay />
      <Modal.Content>
        <Modal.Header>
          <Modal.Title>{t('영수증 확인 안내')}</Modal.Title>
          <Modal.CloseButton size="md" onClick={onClose} />
        </Modal.Header>
        <Modal.Body>
          <Text size="md" color="gray.7">
            {t('네이버페이로 결제한 상세 정보는 아래 경로에서 확인하실 수 있어요.')}
          </Text>
          <Text size="md" color="gray.7" fw={700}>
            {t('[네이버페이 > 결제내역 > 결제 상세정보 > 영수증]')}
          </Text>
        </Modal.Body>
        <Stack spacing={8} px={20} pb={20}>
          <Button
            variant="filled"
            color="infgreen"
            size="md"
            radius="md"
            css={{ fontSize: 16 }}
            onClick={onNaverPayClick}
          >
            {t('네이버페이로 이동')}
          </Button>
          <Button
            mt={8}
            variant="subtle"
            color="gray"
            size="sm"
            css={{ fontSize: 14 }}
            compact
            radius="md"
            onClick={onClose}
          >
            {t('닫기')}
          </Button>
        </Stack>
      </Modal.Content>
    </Modal.Root>
  );
};
